export enum AccountEnviromentEnum {
  cash = 'Conta Cash',
  leverage = 'Alavancagem',
  simulator = 'Simulador',
}
